export default __webpack_public_path__ + "static/media/payment-vnpay.a589d24a.svg";